import { Action } from 'redux';
import { DeliveryLogType, EventLog, InProgressStats, Log } from '@dev/ee-api/ee-api-models';
import { ReactText } from 'react';

import { ExportLogsParams, LogsParams, ResendParams } from '@api/services/ElasticApi';

export interface StdLoadLogsInterface extends LogsParams {
    inProgressLogPage?: number;
    logLoading?: boolean;
    statusesInProgress?: DeliveryLogType[];
    from?: string;
    to?: string;
    perPage?: number;
    skipSagaURL?: boolean;
    includeSms?: boolean;
    includeEmail?: boolean;
    onlyLastEvent?: boolean;
    isNotification?: boolean;
}
export interface LoadLogsStartAction extends Action {
    type: '@@logs/LOAD_LOG_START';
    payload: StdLoadLogsInterface;
}
export interface LoadLogsSuccessAction extends Action {
    type: '@@logs/LOAD_LOG_SUCCESS';
    payload: {
        logList: Log;
        inProgressLogPage?: number;
        totalLogsCount?: number;
        logLoading: boolean;
        statusesInProgress?: DeliveryLogType[];
        hasMoreLogs?: boolean;
    };
}
export interface LoadLogsErrorAction extends Action {
    type: '@@logs/LOAD_LOG_ERROR';
    payload: {
        logLoading: boolean;
    };
}

export interface ClearLogListAction extends Action {
    type: '@@logs/CLEAR_LOG_LIST';
}
export interface ExportLogsAction extends Action {
    type: '@@logs/EXPORT_LOG';
    payload: ExportLogsParams;
}
export interface ExportLogsStartAction extends Action {
    type: '@@logs/EXPORT_LOG_START';
}
export interface ExportLogsSuccessAction extends Action {
    type: '@@logs/EXPORT_LOG_SUCCESS';
}
export interface ExportLogsErrorAction extends Action {
    type: '@@logs/EXPORT_LOG_ERROR';
}

export interface LoadInprogressStatsStartAction extends Action {
    type: '@@logs/LOAD_IN_PROGRESS_STATS_START';
    payload: {
        inProgressLoading: boolean;
        inProgressActivePage?: number;
    };
}
export interface LoadInprogressStatsSuccessAction extends Action {
    type: '@@logs/LOAD_IN_PROGRESS_STATS_SUCCESS';
    payload: {
        inprogressStats: InProgressStats;
        inProgressActivePage?: number;
        inProgressLoading: boolean;
    };
}
export interface LoadInprogressStatsErrorAction extends Action {
    type: '@@logs/LOAD_IN_PROGRESS_STATS_ERROR';
    payload: {
        inProgressLoading: boolean;
    };
}

export interface LoadInprogressStatsStartDelayedAction extends Action {
    type: '@@logs/LOAD_IN_PROGRESS_STATS_DELAYED_START';
    payload: {
        inProgressDelayedLoading: boolean;
        inProgressActivePage?: number;
        inProgressDelayedLoopId: string;
    };
}
export interface LoadInprogressStatsSuccessDelayedAction extends Action {
    type: '@@logs/LOAD_IN_PROGRESS_STATS_DELAYED_SUCCESS';
    payload: {
        inprogressStatsDelayed: InProgressStats;
        inProgressActivePage?: number;
        inProgressDelayedLoading: boolean;
    };
}
export interface SetLoaderInprogressStatsAction extends Action {
    type: '@@logs/SET_INPROGRESS_LOADER';
    payload: {
        setLoader: boolean;
    };
}
export interface LoadInprogressStatsErrorDelayedAction extends Action {
    type: '@@logs/LOAD_IN_PROGRESS_STATS_DELAYED_ERROR';
    payload: {
        inProgressDelayedLoading: boolean;
    };
}

export interface LoadCancelInprogressStartAction extends Action {
    type: '@@logs/CANCEL_IN_PROGRESS_START';
    payload: {
        loading: boolean;
    };
}
export interface LoadCancelInprogressSuccessAction extends Action {
    type: '@@logs/CANCEL_IN_PROGRESS_SUCCESS';
    payload: {
        loading: boolean;
    };
}
export interface LoadCancelInprogressErrorAction extends Action {
    type: '@@logs/CANCEL_IN_PROGRESS_ERROR';
    payload: {
        loading: boolean;
    };
}

export enum NotificationLogsTypes {
    LOAD = '@@logs/LOAD_NOTIFICATION',
    SUCCESS = '@@logs/LOAD_NOTIFICATION_SUCCESS',
}
export interface LoadNotificationLogsAction extends Action {
    type: NotificationLogsTypes.LOAD;
    payload: StdLoadLogsInterface;
}
export interface LoadNotificationLogsSuccessAction extends Action {
    type: NotificationLogsTypes.SUCCESS;
    payload: {
        notificationList: Log;
        inProgressLogPage?: number;
        totalLogsCount?: number;
        logLoading: boolean;
        hasMoreLogs: boolean;
    };
}

export enum LogsActionTypesEnum {
    UPDATE_EVENT_COUNTS = '@@logs/UPDATE_EVENT_COUNTS',
    FETCH_EVENTS_COUNTS = '@@logs/FETCH_EVENTS_COUNTS',
}

export interface UpdateEventsCountsSuccessAction extends Action {
    type: LogsActionTypesEnum.UPDATE_EVENT_COUNTS;
    payload: Record<string, ReactText>;
}

export interface LogsState {
    inProgressLoading?: boolean;
    inProgressDelayedLoading?: boolean;
    inProgressDelayedLoopId?: string;
    inProgressActivePage?: number;
    statusesInProgress?: DeliveryLogType[];
    inProgressLogPage?: number;
    inprogressStats?: InProgressStats;
    inprogressStatsDelayed?: InProgressStats;
    setLoader?: boolean;
    logList?: Log | EventLog;
    notificationList?: Log;
    logLoading: boolean;
    totalLogsCount?: number;
    eventsCounts?: Record<string, any>;
    countsLoading?: boolean;
    hasMoreLogs?: boolean;
}

export interface ResendStartAction extends Action {
    type: '@@logs/RESEND_START';
    payload: {
        params: ResendParams;
    };
}

export interface ResendSuccessAction extends Action {
    type: '@@logs/RESEND_SUCCESS';
}

export interface ResendErrorAction extends Action {
    type: '@@logs/RESEND_ERROR';
}

export enum LogTypesString {
    EMAIL = 'email',
    NOTIFICATION = 'notification',
    SMS = 'sms',
}

export interface FetchEventsCountsPayload extends StdLoadLogsInterface {
    eventType: LogTypesString;
}
export interface FetchEventsCountsAction extends Action {
    type: LogsActionTypesEnum.FETCH_EVENTS_COUNTS;
    payload: FetchEventsCountsPayload;
}
